import { getStore } from '../store';
import { initializeOwaDateTimeStore } from '../actions';
import { orchestrator, mutatorAction } from 'satcheljs';
import getTimeZoneOperation from 'owa-service/lib/operation/getTimeZoneOperation';
import TimeZoneEntry from 'owa-service/lib/contract/TimeZoneEntry';
import TimeZoneRangeType from 'owa-service/lib/contract/TimeZoneRangeType';

orchestrator(initializeOwaDateTimeStore, async () => {
    var { TimeZoneList } = await getTimeZoneOperation({ needTimeZoneList: true });
    updateAllTimeZones(TimeZoneList as Required<TimeZoneRangeType>[]);
});

const updateAllTimeZones = mutatorAction('updateAllTimeZones', function(
    timeZoneList: TimeZoneEntry[]
) {
    getStore().AllTimeZones = timeZoneList;
});
